import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

export class AuthUser {
  id: number;
  firstName: string;
  lastName: string;
  avatar: string;
  organizationId: string;
  created_at: string;
  userRoles: Array<any>;

  constructor() {
    this.userRoles = [];
  }

}

export class UserRole {
  id: number;
  role: string;
  userId: number;
  organizationId: number;
  createdBy: string;
  created_at: string;
  updated_at: string;
}

@Injectable()
export class AppService {

  private authUser: AuthUser;

  constructor(private router: Router) {
    this.authUser = new AuthUser();
  }

  getAuthUser(): AuthUser {
    return this.authUser;
  }

  setAuthUser(user: AuthUser): void {
    this.authUser = user;
  }

  userHasRoles(roleNames: string | Array<string>) {

    if (Array.isArray(roleNames)) {
      let roleExists = false;
      roleNames.forEach((roleName) => {
        roleExists = roleExists || (this.authUser.userRoles.filter((userRole: UserRole) => (userRole.role === roleName)).length > 0);
      });
      return roleExists;
    }

    return this.authUser.userRoles.filter((userRole: UserRole) => (userRole.role === roleNames)).length > 0;

  }

  loginUser(token: string, userID: string, organizationID: string) {
    localStorage.setItem('token', token);
    localStorage.setItem('userID', userID);
    localStorage.setItem('organizationID', organizationID);
    this.router.navigate(['/dashboard']);
  }

  logoutUser() {
    localStorage.removeItem('token');
    localStorage.removeItem('userID');
    localStorage.removeItem('organizationID');
    this.router.navigate(['/login']);
    this.authUser = new AuthUser();
  }

  getToken(): string {
    return localStorage.getItem('token');
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/utils/services/app.service.ts